import * as React from 'react';
import { AppBar, Box, Toolbar, Typography, Container, MenuItem } from '@mui/material';
import { useDimensions } from "src/utils/useDimensions.js";
import { useTheme } from "@emotion/react";
import { useNavigate } from "react-router-dom";
import { getPageRoute } from 'src/services';

const pages = [{
  title: 'Privacy',
  url: getPageRoute("privacy", "PRIVACY"),
},
{
  title: 'Terms',
  url: getPageRoute("terms", "TERMS"),
}];

function MaestroFooter({ variant = "light" }) {
  const navigate = useNavigate();
  const { isMediumScreen } = useDimensions();
  const theme = useTheme();
  const isDark = variant === "dark";
  const footerSmall = { boxShadow: "none !important" };
  const bgColor = isDark ? "#000000" : "white";
  const linkColor = isDark ? "rgba(255,255,255,0.6)" : "grey";

  return (
    <Box style={{ display: 'flex', justifyContent: 'center', bottom: 0, width: '100%', marginTop: 'auto' }}>
      <AppBar position="static" sx={{ backgroundColor: bgColor, ...footerSmall }}>
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            <Box sx={{ flexGrow: 1, display: { xs: 'flex' }, alignItems: 'center', textAlign: 'center', justifyContent: 'center' }}>
              {pages.map((page) => (
                <MenuItem key={page.title} onClick={() => navigate(page.url)}>
                  <Typography textAlign="center" variant="footer" sx={{ color: linkColor, mr: 1 }}>{page.title}</Typography>
                </MenuItem>
              ))}
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
    </Box>
  );
}

export default MaestroFooter; 